<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Whatsapp Outlined" class="d-icon d-icon--whatsapp-outlined" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.543 2.453A4.958 4.958 0 0 0 6.02 1C3.275 1 1.042 3.223 1.04 5.955c0 .873.23 1.726.665 2.477L1 11l2.64-.689a4.991 4.991 0 0 0 2.379.603h.002c2.744 0 4.978-2.223 4.979-4.955a4.913 4.913 0 0 0-1.457-3.506ZM6.02 10.077h-.002c-.742 0-1.47-.199-2.106-.574l-.151-.09-1.567.41.418-1.52-.098-.156a4.093 4.093 0 0 1-.633-2.192c.001-2.27 1.858-4.118 4.14-4.118a4.12 4.12 0 0 1 2.926 1.208 4.083 4.083 0 0 1 1.211 2.913c0 2.271-1.857 4.119-4.138 4.119Zm2.27-3.084a20.625 20.625 0 0 0-.85-.403c-.114-.041-.197-.062-.28.062a7.121 7.121 0 0 1-.394.485c-.073.083-.145.093-.27.031-.124-.062-.525-.192-1-.614a3.735 3.735 0 0 1-.692-.858c-.073-.124-.008-.19.054-.252.056-.056.125-.145.187-.217.062-.073.083-.124.124-.207.042-.083.021-.155-.01-.217-.03-.062-.28-.671-.384-.919-.1-.241-.203-.209-.28-.213a5.043 5.043 0 0 0-.238-.004.458.458 0 0 0-.332.155c-.114.124-.435.424-.435 1.033s.446 1.198.508 1.28c.062.083.877 1.334 2.125 1.87.297.128.529.204.71.261.297.095.569.081.783.05.239-.036.736-.3.84-.59.103-.289.103-.537.072-.588-.03-.052-.114-.083-.238-.145Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconWhatsappOutlined',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
